export enum TipoResposta {
    Texto = 0,
    Numero = 1,
    Mascara = 2,
    Imagem = 3,
    Arquivo = 4,
    MultiplaEscolha = 5
}
